// Registered through `auth.plugins` in nuxt.config.js so `$auth` is ready.
//
// A browser can hold an access token the API rejects (client clock behind,
// lost `auth_token_expiration.local` cookie, ...). auth-next only refreshes a
// token it considers expired, so such a token is attached to every request
// and the API answers 401 everywhere, including the public endpoints the
// login page depends on. Nothing clears the cookies since resetOnError was
// removed, so the browser stays broken until the user deletes cookies.
//
// On a 401 from the initial user fetch this tries one refresh and otherwise
// resets the session, which drops the stale cookies.
export default function ({ $auth }) {
  let recovering = false

  async function recover () {
    console.log('[auth-recover] recovering')
    const refreshToken = $auth.strategy?.refreshToken
    const canRefresh = refreshToken?.get() && !refreshToken.status().expired()

    if (!canRefresh) {
      console.log('[auth-recover] no refresh token')
      $auth.reset()
      return
    }

    try {
      console.log('[auth-recover] refreshing tokens')
      await $auth.refreshTokens()
      await $auth.fetchUser()
    } catch (e) {
      $auth.reset()
    }
  }

  $auth.onError((error, { method } = {}) => {
    if (method !== 'fetchUser' || error?.response?.status !== 401 || recovering) {
      console.log('[auth-recover] ignoring error')
      return
    }

    recovering = true
    recover().finally(() => {
      recovering = false
    })
  })
}
